/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Message_Copied_To_ClipboardInputs */



/**
* | output |
* | --- |
* | "Message copied to clipboard" |
*
* @param {Chat_Message_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_message_copied_to_clipboard = /** @type {((inputs?: Chat_Message_Copied_To_ClipboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Message_Copied_To_ClipboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachricht in die Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("Message copied to clipboard")
});